<template>
  <Comment
    :addGmfContextClass="true"
    v-if="topComment"
    :comment="topComment"
    :collapse="true"
    :description="description"
    :disableReplies="true"
    :elements="{
        title: false,
        prosAndCons: false,
        uploads: false,
        footer: false,
        customerLevel: false,
        animateAvatar: true,
        target: false,
        date: false,
        translateButton: false
    }"
    :leftColumnAvatar="true"
  />
  <SocialBannerMini v-else-if="enableSocialBannerPlaceholder" />
</template>

<style>
.gmf-top-review .gmf-comment-customer-col {
  width: 80px;
  padding-top: 0;
  justify-content: center;
}
.gmf-top-review .gmf-comment-content {
  width: 100%;
}

.gmf-top-review {
  width: 100%;
}
</style>

<script>
/*

voting on/off??
disable replies - NO REPLIES
some sort of header thingy

*/
import Comment from '@/components/Comment';

import state from '@/state';

const tc = state.t.prefix('comments');

import getTopComment from './getTopComment';
import SocialBannerMini from '@/components/SocialBannerMini';

export default {
  props: ['productId', 'mockJson'],
  components: {
    SocialBannerMini,
    Comment,
  },
  data () {
    return {
      topComment: null,
      hasLoaded: false,
    };
  },
  computed: {
    injectedComment () {
      if (! this.mockJson) {
        return null;
      }
      try {
        return JSON.parse(this.mockJson);
      } catch (e) {
        return null;
      }
    },
    enableSocialBannerPlaceholder () {
      if (! this.hasLoaded) {
        return false;
      }
      return state.merchantConfig?.widgets?.topReview?.socialBannerPlaceholder?.enable;
    },
    description () {
      if (this.topComment.type.name === 'product_review') {
        return tc('top_review');
      }
      if (this.topComment.type.name === 'product_hype') {
        return tc('top_hype');
      }
      return tc('top_hype');
    },
  },
  async mounted () {
    if (this.injectedComment) {
      this.topComment = this.injectedComment;
      return;
    }

    const res = await getTopComment(this.productId);
    if (res) {
      this.topComment = res;
    }
    this.hasLoaded = true;
  },
};
</script>
